export default function FnB() {
  return <div className="p-6 text-center text-xl">Food & Beverages Page</div>;
}